import type { SVGProps } from "react";

const CommsIcon = ({
  width = 30,
  height = 30,
  ...props
}: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 30 30"
    fill="none"
    {...props}
  >
    <path
      fill="#000"
      fillRule="evenodd"
      d="M5 5.868v17.5a3.75 3.75 0 0 0 3.75 3.75h12.5a3.75 3.75 0 0 0 3.75-3.75v-12.5a3.75 3.75 0 0 0-3.75-3.75h-15c-.69 0-1.25-.56-1.25-1.25Zm4.063 8.75c0-.518.42-.937.937-.937h10a.938.938 0 0 1 0 1.875H10a.937.937 0 0 1-.938-.938Zm0 4.375c0-.518.42-.937.937-.937h6.875a.938.938 0 0 1 0 1.875H10a.937.937 0 0 1-.938-.938Z"
      clipRule="evenodd"
    />
    <path
      fill="#000"
      d="M22.5 5v2.331a3.744 3.744 0 0 0-1.25-.213h-15c-.69 0-1.25-.56-1.25-1.25v-.089c0-.666.49-1.231 1.15-1.325l13.496-1.928A2.5 2.5 0 0 1 22.5 5Z"
      opacity={0.5}
    />
  </svg>
);
export default CommsIcon;
